import { atom } from 'recoil';

export const DataLinkState = atom({
    key: 'DataLinkState',
    default: null
});